import { ChartTooltipWrapperProps } from '@modules/charts/components/ChartTooltipWrapper/ChartTooltipWrapper';
import { ActiveMergeSuggestion, Reason } from '@modules/taxonomy/store/types';
import { TimeRange, TimeUnit } from 'v2/core/entities';
import { FieldNames } from 'v2/core/entities/fields';
import { QueryContainer } from 'v2/core/services/notebook/types';
import {
  EmptyWhereClause,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';
import { create, StoreApi } from 'zustand';
import createContext from 'zustand/context';

// TODO: Rename this to something more descriptive as it's not being used in charts only. Tables are using it too.

interface ChartTooltipData {
  fieldName: FieldNames | null;
  qbField: string | null;
  baseWhereClause: WhereClause;
  dateRange: TimeRange;
  dataPointWhereClause: WhereClause;
  shouldOpenFeedbackDrawer: boolean;
  shouldShowConfirmMergeDrawer: boolean;
  payload: ChartTooltipWrapperProps['payload'] | null;
  feedbackQueryContainer: QueryContainer | null;
  shouldShowAddToFilter: boolean;
  shouldShowEditReason: boolean;
  shouldShowMergeReason: boolean;
  activeMergeSuggestion: ActiveMergeSuggestion | null;
  activeReason: Reason | null;
  shouldShowEditReasonDrawer: boolean;
}

export interface ChartTooltipState extends ChartTooltipData {
  setData: (
    value:
      | Partial<ChartTooltipData>
      | ((prevState: ChartTooltipData) => Partial<ChartTooltipData>),
  ) => void;
}

const createChartTooltipStore = () => {
  const useChartTooltipStore = create<ChartTooltipState>((set) => ({
    fieldName: null,
    qbField: null,
    baseWhereClause: EmptyWhereClause,
    dataPointWhereClause: EmptyWhereClause,
    dateRange: { type: 'last', unit: TimeUnit.Month, value: 3 },
    shouldOpenFeedbackDrawer: false,
    feedbackQueryContainer: null,
    payload: null,
    shouldShowAddToFilter: true,
    shouldShowEditReason: true,
    shouldShowMergeReason: true,
    setData: (value) =>
      set((state) => ({
        ...state,
        ...(typeof value === 'function' ? value(state) : value),
      })),
    shouldShowConfirmMergeDrawer: false,
    activeMergeSuggestion: null,
    activeReason: null,
    shouldShowEditReasonDrawer: false,
  }));

  return useChartTooltipStore;
};

const { Provider, useStore } = createContext<StoreApi<ChartTooltipState>>();

export {
  Provider as ChartTooltipStoreProvider,
  createChartTooltipStore,
  useStore as useChartTooltipStore,
};
